// extracted by mini-css-extract-plugin
export default {"table":"Loading_table__HAauZ","emptyScan":"Loading_emptyScan__oayV+","emptySpanHeader":"Loading_emptySpanHeader__NeOPY","emptySpan":"Loading_emptySpan__GLxeJ"};